<template>
  <ContactForm :config="config" />
</template>

<script>
import ContactForm from "../../components/ContactForm/ContactForm.vue";

export default {
  name: "app",
  components: {
    ContactForm
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
